
// reportWebVitals.js - disattivato per produzione
const reportWebVitals = () => {
  // Nessuna misurazione per evitare log in console
};

export default reportWebVitals;
